module.exports = __webpack_public_path__ + "img/partner7.05db7182.png";